import { c as _c } from "react/compiler-runtime";
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useWorldDetailsContext } from '@/context/WorldDetailsContext';
import { useMobilePlayCtaVariant } from '@/hooks/useMobilePlayCtaVariant';
import { useMobileWorldRedirectUrlBuilder } from '@/hooks/useMobileWorldRedirectUrl';
import { useTranslations } from 'next-intl';

/**
 * Click target that makes the portrait media itself a Play target for the `icon-label` and
 * `icon-only` experiment arms. Returns `null` when the arm, layout or world does not use it.
 */
export function useMobilePlayMediaLink() {
  const $ = _c(11);
  const t = useTranslations();
  const {
    isVoucherCheckPassed,
    roomData
  } = useCheckEnterRoomContext();
  const {
    showMobilePlayButton
  } = useWorldDetailsContext();
  const {
    captureAttributes,
    capturePlayClick,
    isIconLabel,
    isIconOnly
  } = useMobilePlayCtaVariant();
  const getRedirectUrl = useMobileWorldRedirectUrlBuilder();
  if (!(isIconLabel || isIconOnly) || !showMobilePlayButton || isVoucherCheckPassed === false) {
    return null;
  }
  const labelKey = roomData.content_type?.code === "experiences" ? "world-info.launch" : "world-info.play-game";
  let t0;
  if ($[0] !== labelKey || $[1] !== t) {
    t0 = t(labelKey);
    $[0] = labelKey;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== capturePlayClick || $[4] !== getRedirectUrl) {
    t1 = () => {
      capturePlayClick();
      window.location.href = getRedirectUrl({
        isFull3d: true
      });
    };
    $[3] = capturePlayClick;
    $[4] = getRedirectUrl;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== captureAttributes || $[7] !== isIconOnly || $[8] !== t0 || $[9] !== t1) {
    t2 = {
      captureAttributes,
      isIconOnly,
      label: t0,
      onPlay: t1
    };
    $[6] = captureAttributes;
    $[7] = isIconOnly;
    $[8] = t0;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}